<div class="platform-main-container {{ fullHeight ? 'full' : '' }}">
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>

